import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { SendMoneyService } from '../../_services/sendmoneyservice/sendmoneyservice';
export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class DeactivateGuardService implements CanDeactivate<CanComponentDeactivate> {
  constructor(private sendMoneyService: SendMoneyService) {}
  canDeactivate(
    component: CanComponentDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const path = nextState.url.split('/')[1];

    const componentTmp: any = component;
    let flag: boolean;
    this.sendMoneyService.getDeactivateSummaryFlag().subscribe(data => {
      flag = data;
    });

    if (flag == true) {
      this.sendMoneyService.setDeactivateSummaryFlag(false);
      return true;
    }

    if (
      (path == 'addaccountdetail' && componentTmp.selectedIndex == 1) ||
      (path == 'debitcard' && componentTmp.selectedIndex == 3) ||
      path == 'bankdetails' ||
      path == 'payatstore' ||
      path == 'agentdetails' ||
      path == 'storedetails' ||
      path == 'branches' ||
      path == 'branchedetails' ||
      path == 'login' ||
      path == 'splashscreen' ||
      path == 'PaymentReceipt' ||
      path == 'sendmoney'
    ) {
      return true;
    }
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_common/deactivate-guard.service.ts